import { render, staticRenderFns } from "./InviteFriendsShareSocialCard.vue?vue&type=template&id=10d3fdf8&"
import script from "./InviteFriendsShareSocialCard.vue?vue&type=script&lang=js&"
export * from "./InviteFriendsShareSocialCard.vue?vue&type=script&lang=js&"
import style0 from "./InviteFriendsShareSocialCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports